/**
 * 请注意：不要修改模型中的任何字段名
 * 此处使用了后端的不要脸端口
 * 后端不负责定义字段
 * 完全根据前端传参存取
 * */

/**
 * 年级管理
 * @description 功能模型
 */

import Grade from './Grade'

import { getConfigListByGroup } from '@/api/config'

const CONFIG_GROUP = 'TouchGrade'

export default class GradeManage extends Grade {
    /** 自定义年级展示文案 */
    gradeText
    /** 对应的售卖课期 ID */
    courseStageId
    /** SKU ID */
    skuId
    /** SPU ID */
    spuId

    constructor (data = {}) {
        super(data)
        this.gradeText = data.gradeText
        this.courseStageId = data.courseStageId
        this.skuId = data.skuId
        this.spuId = data.spuId
    }

    /** 获取年级配置列表 */
    static async getList () {
        let response = await getConfigListByGroup({
            group: CONFIG_GROUP
        })
        let data = response.data || []
        let list = data.map(config => {
            let grade = new GradeManage(JSON.parse(config.value))
            return grade
        })
        return list
    }
}
